import { useQuery } from "react-query";
import { toast } from "react-toastify";
import { getAnalysis } from "api/Finances";

export const useAnalysis = (filter_date: { year: number, month: number }) => {

    const { data, isLoading } = useQuery<Array<any>>(
        ['analysisCost', filter_date],
        () => {
            return getAnalysis({
                filter_date: filter_date.year + '-' + filter_date.month,
            });
        }, {
        onError() {
            toast.error(`Something went wrong. Please try again later.`);
        },
    }
    );

    return {
        data,
        isLoading,
    };
};
